module.exports = __webpack_public_path__ + "img/chr_ts_8.a0476372.png";